
import React from 'react';
import { FeatureGuide } from '@/types/knowledgeBase';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Calendar, FileText } from 'lucide-react';

interface FeatureGuideListProps {
  guides: FeatureGuide[];
  selectedGuide: FeatureGuide | null;
  onSelectGuide: (guide: FeatureGuide) => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const FeatureGuideList: React.FC<FeatureGuideListProps> = ({
  guides,
  selectedGuide,
  onSelectGuide,
  searchTerm,
  activeTab
}) => {
  if (!guides || guides.length === 0) {
    return (
      <div className="p-4 text-center">
        <div className="text-gray-500 mb-2">No guides found</div>
        {searchTerm && (
          <div className="text-sm text-gray-400">
            Try adjusting your search or category filter
          </div>
        )}
      </div>
    );
  }

  return (
    <ScrollArea className="h-[500px] px-4">
      <div className="space-y-3 py-4">
        {guides.map((guide) => (
          <div
            key={guide.id}
            onClick={() => onSelectGuide(guide)}
            className={`
              p-3 rounded-md cursor-pointer transition-colors
              ${selectedGuide?.id === guide.id 
                ? 'bg-primary/10 border-l-4 border-primary' 
                : 'hover:bg-gray-100 border-l-4 border-transparent'}
            `}
          >
            <div className="flex items-start justify-between">
              <div>
                <div className="font-medium line-clamp-2">{guide.title}</div>
                <div className="text-sm text-gray-500 mt-1 line-clamp-2">
                  {guide.description}
                </div>
                <div className="flex items-center text-xs text-gray-400 mt-2">
                  <Calendar className="h-3 w-3 mr-1" />
                  {guide.lastUpdated}
                  <span className="mx-2">•</span>
                  <FileText className="h-3 w-3 mr-1" />
                  {guide.category}
                  {guide.isNew && (
                    <span className="ml-2 bg-green-100 text-green-800 text-xs px-1.5 py-0.5 rounded-full text-[10px]">
                      New
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </ScrollArea>
  );
};

export default FeatureGuideList;
